export default {
  set_header: 'Settings',
  set_logout: 'Sign out of account',
  set_dialog_title: 'Are you sure you want to log out of your account?',
  set_dialog_content: 'We will stay here and wait for your return.',
  set_bt_confirm: 'Sign out of account',
  set_bt_cancel: 'Cancel',
  set_account: 'Account',
  set_keys: 'Keys',
  set_withdraw: 'Withdraw',
  set_security: 'Security',
  set_verify_account: 'Verification',
  set_account_id: 'Account ID',
  set_secret_seed: 'Private key',
  set_copy_secret_seed: 'Copy private key',
  set_your_account_id: 'Your Account ID',
  set_change_password: 'Change password',
  set_change_uplata_insha: 'Cards Visa Insha',
  set_change_taid: 'Cards UPLATA',
  set_provide_pwd: 'Provide a new password',
  set_help_pwd: 'A strong password helps prevent unauthorized access to your account',
  set_pwd_do_not_match: 'Passwords do not match',
  set_pwd_changed: 'Password changed',
  set_tfa: 'Two-factor authentication',
  set_tfa_enable: 'Enable 2FA',
  set_tfa_copy_code: 'Scan 2FA code',
  set_tfa_scan_the_qr_code: 'Scan the QR with your 2FA app',
  set_or_manually_enter: 'Or manually enter the secret code',
  set_paste_tfa_code: 'Provide ',
  set_seed_description: 'Private key is private information that proves you own your account',
  set_uplata_insha_added: 'Visa Insha card is added with success',
  set_uplata_insha_changed: 'Autowithdraw parameters of Visa Insha are changed',
  set_uplata_insha_deleted: 'Visa Insha card is deleted with success',
  set_confirm_autowithdraw_change: 'Only single card is allowed for autowithdrawal. \nDo you want to disable autowithdraw for %{name} id="%{id}"?',
  set_taid_added: 'UPLATA card is added with success',
  set_taid_changed: 'Autowithdraw options of UPLATA are changed',
  set_taid_deleted: 'UPLATA card is deleted with success',
  set_cards_changed: 'Autowithdraw options for cards are changed',
  set_my_cards: 'My cards',
  set_change_xpay: 'Payment card'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/settings_view.js